import { useReducer } from 'react';

/**
 * Force a function component to re-render
 *
 * Based on https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
 *
 * @example
 * const Component = () => {
 *   // ...
 *   const forceUpdate = useForceUpdate();
 *
 *   useEffect(() => {
 *     if (something) {
 *       forceUpdate();
 *     }
 *   }, [something]);
 *
 *   // ...
 * };
 */
const useForceUpdate: () => () => void = () => {
  const [, forceUpdate] = useReducer(value => value + 1, 0);

  return forceUpdate;
};

export { useForceUpdate };
